import React from 'react'
import DataTracker from '@common/dataTracker'

interface IParams {
  category?: string
  label?: string
  mapkv: {}
}
export interface ITrackerProps {
  tracker: (params: IParams) => void
}

const withTracker = <P extends ITrackerProps>(Comp: React.ComponentType<P>) => (
  props: Omit<P, keyof ITrackerProps>
) => {
  return (
    <Comp
      {...(props as P)}
      tracker={params => DataTracker.singleTrackEvent(params)}
    />
  )
}
export default withTracker
